import Duties from "./Duties";

export default Duties;